import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_exportadores';
import styles from "./styles.module.css";
import { BsFillPlusCircleFill, BsXCircleFill } from "react-icons/bs";
import Swal from 'sweetalert2';
import { CSVLink, CSVDownload } from "react-csv";
import queryString from 'query-string';
import { useLocation } from 'react-router';

export default function NovoExportador() {

    const { id } = queryString.parse(useLocation().search);

    const [descricao, setDescricao] = useState('');
    const [sql, setSql] = useState('');
    const [parametros, setParametros] = useState([]);
    const [gravando, setGravando] = useState(false);
    const [modalTestarOpen, setModalTestarOpen] = useState(false);
    const [teste, setTeste] = useState([]);
    const [campos, setCampos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [modalUsuariosOpen, setModalUsuariosOpen] = useState(false);
    const [roda, setRoda] = useState(true);
    const [checkAllUsuarios, setCheckAllUsuarios] = useState(false);

    const [tipoFiltro, setTipoFiltro] = useState({
        items: [
        ],
        selectItem: 0
    });

    const [tipoCampo, setTipoCampo] = useState({
        items: [
        ],
        selectItem: 0
    });

    useEffect(() => {

        if (usuarios.length > 0) {

            if (roda) {
                api.get(`/id/${id}`).then(function (response) {
                    if (response.data) {
                        setSql(response.data.script);
                        setDescricao(response.data.descricao);
                        setParametros(response.data.filtros);
                        if (response.data.usuarios_exportador && response.data.usuarios_exportador.length > 0) {

                            var objuser = Object.assign([], usuarios);

                            response.data.usuarios_exportador.map((usuario) => {
                                var selected = usuarios.find(user => user.id === usuario.usuario_id);
                                selected.checked = 1;
                            });

                            setUsuarios(objuser);
                        }
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    setRoda(false);
                });
            }
        }

    }, [id, usuarios]);

    useEffect(() => {
        if (teste.length > 0) {
            setCampos(Object.keys(teste[0]));
        }
    }, [teste]);

    useEffect(() => {
        api.get(`/getusers`).then(function (response) {
            if (response.data) {
                setUsuarios(response.data)
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, []);

    useEffect(() => {
        api.get(`/tipocampo`).then(function (response) {
            if (response.data) {
                var itens = [];
                response.data.forEach(tipocampo => {
                    var item = {}
                    item.id = tipocampo.id;
                    item.text = tipocampo.descricao;
                    itens.push(item);
                })
                var tipocampoobj = {}
                tipocampoobj.items = itens;
                tipocampoobj.selectItem = response.data[0].id;
                setTipoCampo(tipocampoobj);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, []);

    useEffect(() => {
        api.get(`/tipofiltro`).then(function (response) {
            if (response.data) {
                var itens = [];
                response.data.forEach(tipofiltro => {
                    var item = {}
                    item.id = tipofiltro.id;
                    item.text = tipofiltro.descricao;
                    itens.push(item);
                })
                var tipofiltroobj = {}
                tipofiltroobj.items = itens;
                tipofiltroobj.selectItem = response.data[0].id;
                setTipoFiltro(tipofiltroobj);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, []);


    function rendertipoCampo(parametro, index) {


        const handleSetTipoCampo = function (valor) {
            var objparam = Object.assign([], parametros)
            var selectedparam = objparam.find(param => param.index === index);
            selectedparam.exp_tipo_campos_id = parseInt(valor);
            setParametros(objparam);
        }

        return (
            <div className={styles.paramcontent} key={`campo${index}`}>
                TIPO DO CAMPO
                <select
                    key={`campo${index}`}
                    className="col-md-12 combobox  edit form-control column-filtro"
                    id="tipo"
                    value={parametro.exp_tipo_campos_id}
                    onChange={(e) => handleSetTipoCampo(e.target.value)}
                >
                    {tipoCampo.items.map((item, index) => (
                        <option key={`campo${index}`} value={item.id}>{item.text}</option>
                    ))}
                </select>
            </div>
        )
    }

    function rendertipoFiltro(parametro, index) {


        const handleSetTipoFiltro = function (valor) {
            var objparam = Object.assign([], parametros)
            var selectedparam = objparam.find(param => param.index === index);
            selectedparam.exp_tipo_filtros_id = parseInt(valor);
            setParametros(objparam);
        }

        return (
            <div className={styles.paramcontent} key={`filtro${index}`}>
                TIPO DO CAMPO
                <select
                    key={`filtro${index}`}
                    className="col-md-12 combobox  edit form-control column-filtro"
                    id="tipo"
                    value={parametro.exp_tipo_filtros_id}
                    onChange={(e) => handleSetTipoFiltro(e.target.value)}
                >
                    {tipoFiltro.items.map((item, index) => (
                        <option key={`filtro${index}`} value={item.id}>{item.text}</option>
                    ))}
                </select>
            </div>
        )
    }

    function renderDescricao(parametro, index) {
        const setdesc = function (valor) {
            var objparam = Object.assign([], parametros)
            var selectedparam = objparam.find(param => param.index === index);
            selectedparam.desc_parametro = valor;
            setParametros(objparam);
        }
        return (
            <div className={styles.paramcontent}>
                DESCRIÇÃO
                <input
                    type="text"
                    value={parametro.desc_parametro}
                    onChange={(e) => setdesc(e.target.value)}
                />
            </div>
        )
    }

    function renderValorPadrao(parametro, index) {
        const setvlrp = function (valor) {
            var objparam = Object.assign([], parametros)
            var selectedparam = objparam.find(param => param.index === index);
            selectedparam.valores_padrao = valor;
            setParametros(objparam);
        }
        return (
            <div className={styles.paramcontent}>
                VALOR PADRÃO
                <input
                    type="text"
                    value={parametro.valores_padrao}
                    onChange={(e) => setvlrp(e.target.value)}
                />
            </div>
        )
    }

    function renderObrigatorio(parametro, index) {

        const setobrigatorio = function (valor) {
            var objparam = Object.assign([], parametros)
            var selectedparam = objparam.find(param => param.index === index);
            selectedparam.required = parseInt(valor);
            setParametros(objparam);

        }

        const render = function (parametro) {
            if (parametro.required === 1) {
                return (
                    <div className={styles.paramcontent} >
                        OBRIGATÓRIO
                        <input type="checkbox" checked onChange={() => setobrigatorio(0)} />
                    </div>
                )
            } else {
                return (
                    <div className={styles.paramcontent}>
                        OBRIGATÓRIO
                        <input type="checkbox" onChange={() => setobrigatorio(1)} />
                    </div>
                )
            }
        }

        return (
            render(parametro)
        )
    }

    function renderAgrupamento(parametro, index) {

        const setAgrup = function (valor) {
            var objparam = Object.assign([], parametros)
            var selectedparam = objparam.find(param => param.index === index);
            selectedparam.agrupamento = valor;
            setParametros(objparam);
        }
        
        return (
            <div className={styles.agrup}>
                AGRUP
                <input
                    type="text"
                    value={(parametro.agrupamento === undefined ? index : parametro.agrupamento)}
                    onChange={(e) => setAgrup(e.target.value)}
                />
            </div>
        )
    }

    function handleApagarParam(index) {
        var objparam = Object.assign([], parametros);
        var newarray = objparam.splice(index, 1)
        setParametros(objparam);

    }

    function renderParametros(parametros) {
        return (
            parametros.map((parametro, index) => {
                return (
                    <div className={styles.parametro}>
                        {renderDescricao(parametro, index)}
                        {renderValorPadrao(parametro, index)}
                        {renderObrigatorio(parametro, index)}
                        {rendertipoCampo(parametro, index)}
                        {rendertipoFiltro(parametro, index)}
                        {renderAgrupamento(parametro, index)}
                        <div className={styles.btnapagar}>
                            <BsXCircleFill
                                size="25"
                                color='red'
                                onClick={() => handleApagarParam(index)}
                            />
                        </div>
                    </div>
                )
            })
        )
    }

    function handleNewParametro() {
        var par = Object.assign([], parametros);
        var index = par.length;
        var obj = {};
        obj.index = index++;
        obj.desc_parametro = '';
        obj.valores_padrao = '';
        obj.required = 0;
        obj.exp_tipo_campos_id = tipoCampo.selectItem;
        obj.exp_tipo_filtros_id = tipoFiltro.selectItem;
        par.push(obj)
        setParametros(par);
    }

    function gravar() {

        if (!descricao || descricao === "") {
            Swal.fire('A DESCRIÇÃO NÃO PODE FICAR EM BRANCO!')
            return;
        }

        if (!sql || sql === "") {
            Swal.fire('O SCRIPT NÃO PODE FICAR EM BRANCO!')
            return;
        }

        if (parametros.length > 0) {
            parametros.map((parametro, index) => {
                if (parametro.agrupamento === undefined || parametro.agrupamento === null) {
                    parametro.agrupamento = index;
                }
                if (!parametro.desc_parametro || parametro.desc_parametro === '') {
                    Swal.fire('A DESCRIÇÃO DOS PARAMETROS NÃO PODEM FICAR EM BRANCO!')
                    return;
                }
            })
        }

        var selectedusers = [];

        usuarios.map((usuario) => {
            if (usuario.checked) {
                selectedusers.push(usuario);
            }
        })

        if (selectedusers.length < 1) {
            Swal.fire('NÃO HÁ USUÁRIOS SELECIONADOS!')
            return;
        }

        if (!gravando) {
            setGravando(true);
            var obj = {}
            obj.descricao = descricao;
            obj.sql = sql;
            obj.usuarios = selectedusers;
            if (parametros.length > 0) {
                obj.hasfilter = 1;
                obj.parametros = parametros;
            }
            if (id && id !== '') {
                obj.id = id;
                api.put(`/`, obj).then(function (response) {
                    if (response.data) {
                        Swal.fire('EXPORTADOR ATUALIZADO COM SUSCESSO');
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    setGravando(false);
                });
            } else {
                api.post(`/`, obj).then(function (response) {
                    if (response.data) {
                        Swal.fire('EXPORTADOR GRAVADO COM SUSCESSO');
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    setGravando(false);
                });
            }
        }
    }

    function testar() {
        setModalTestarOpen(true);
    }

    function fechaModalCadProjetos() {
        setModalTestarOpen(false);
    }

    function renderParametrosTestar() {
        return (
            parametros.map((parametro) => {
                return (
                    <div>
                        <div>
                            {parametro.desc_parametro}
                        </div>
                        <input type="text" value={parametro.valores_padrao} readOnly/>
                    </div>
                )
            })
        )
    }

    function rodarTeste() {
        var obj = {};
        obj.sql = sql;
        obj.parametros = parametros;
        api.post(`/testar`, obj).then(function (response) {
            if (response.data) {
                setTeste(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            setGravando(false);
        });
    }

    function renderCamposTabela() {
        if (campos.length > 0) {
            return (
                campos.map((campo) => {
                    return (
                        <th>{campo}</th>
                    )
                })
            )
        }

    }

    function renderValor(valores) {
        return (
            valores.map((valor) => {
                return (
                    <td>{valor}</td>
                )
            })
        )
    }

    function renderValoresTabela() {
        return (
            teste.map((t) => {
                var valores = Object.values(t);
                return (
                    <tr>{renderValor(valores)}</tr>
                )
            })

        )
    }

    function renderTableTeste() {

        return (
            <table className='table table-sm'>
                <thead>
                    <tr>
                        {renderCamposTabela()}
                    </tr>
                </thead>
                <tbody>
                    {renderValoresTabela()}
                </tbody>
            </table>
        )

    }

    function renderModalTestar() {
        return (
            <div
                className={(modalTestarOpen ? "modal-despesas" : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalCadProjetos()}
                ><b>x</b></span>
                <div>
                    <h3><b>TESTAR EXPORTADOR</b></h3>
                </div>
                <div className={styles.contentparamtestar}>
                    {renderParametrosTestar()}
                </div>
                <input type="button" value="testar" className='btn-teste btn btn-success' onClick={() => rodarTeste()} />
                <CSVLink
                    data={teste}
                    separator={";"}
                    className="btn-teste btn btn-success"
                >
                    Download
                </CSVLink>
                {renderTableTeste()}
            </div>
        )
    }

    function fechaModalUsuarios() {
        setModalUsuariosOpen(false);
    }

    function handleCheckUsuario(usuario, checked) {
        var objuser = Object.assign([], usuarios);
        var selecteduser = objuser.find(u => u.id === usuario.id);
        selecteduser.checked = checked;
        setUsuarios(objuser)
    }

    function renderCheckUsuario(usuario) {
        if (usuario.checked) {
            return (
                <input type="checkbox" onClick={() => handleCheckUsuario(usuario, 0)} checked />
            )
        } else {
            return (
                <input type="checkbox" onClick={() => handleCheckUsuario(usuario, 1)} />
            )
        }

    }

    function renderUsuarios() {
        return (
            usuarios.map((usuario) => {
                return (
                    <div className={styles.contentusuario}>
                        {renderCheckUsuario(usuario)}
                        <div className={styles.usuario}>
                            {usuario.usuario}
                        </div>
                    </div>
                )
            })
        )
    }

    function handleCheckAllUsuario(check){

        if(check){
            setCheckAllUsuarios(true);
            var objUsuarios = Object.assign([], usuarios);
            objUsuarios.forEach((usuario) => {
                usuario.checked = true;
            })
        } else {
            setCheckAllUsuarios(false);
            var objUsuarios = Object.assign([], usuarios);
            objUsuarios.forEach((usuario) => {
                usuario.checked = false;
            })
        }
    }


    function renderCheckAllUsuarios(){
        if(checkAllUsuarios){
            return (
                <input type="checkbox" onClick={() => handleCheckAllUsuario(0)} checked />
            )
        } else {
            return (
                <input type="checkbox" onClick={() => handleCheckAllUsuario(1)} />
            )
        }
    }

    function renderModalUsuarios() {
        return (
            <div
                className={(modalUsuariosOpen ? "modal-despesas" : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalUsuarios()}
                ><b>x</b></span>
                <div>
                    <h3>{renderCheckAllUsuarios()}<b>USUÁRIOS</b></h3>
                </div>
                <div className={styles.gridusuarios}>
                    {renderUsuarios()}
                </div>
            </div>
        )
    }

    function handleOpenModalUsuario() {
        setModalUsuariosOpen(true);
    }

    return (
        <>
            {renderModalTestar()}
            {renderModalUsuarios()}
            <div className="container-lg">
                <Header title="CADASTRAR NOVO EXPORTADOR" />
                <div className={styles.form}>
                    <div className={styles.conjunto}>
                        <div>
                            DESCRIÇÃO
                        </div>
                        <input type="text" value={descricao} onChange={(e) => setDescricao(e.target.value)} className={styles.descricao} />
                    </div>
                    <div className={styles.conjunto}>
                        <div>
                            SQL
                        </div>
                        <textarea id="sql" name="sql" rows="1" className={styles.textarea} value={sql} onChange={(e) => setSql(e.target.value)}> </textarea>
                    </div>
                </div>
                <div className={styles.bodyparam}>
                    <div className={styles.inner}>
                        PARAMETROS
                        <hr></hr>
                    </div>
                    {renderParametros(parametros)}
                    <div>
                        <BsFillPlusCircleFill onClick={() => handleNewParametro()} />
                    </div>
                    <hr></hr>
                    <input type="button" value="ATRIBUIR USUÁRIOS" className='btn-primary' onClick={() => handleOpenModalUsuario()} />
                    <hr></hr>
                    <input type="button" value="TESTAR IMPORTADOR" onClick={() => testar()} className="btn-success" />
                    <input type="button" value="GRAVAR" onClick={() => gravar()} className="btn-success" />
                </div>

            </div>
        </>
    )
}